/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED MANAGEMENT : STYLES --------------- ++++++++++ */
export default theme => ({
    embedManagement: {
        // section styles
        '& #main': {
            textAlign: 'center',
            '& #wrapper': {
                '& .page': {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    overflowX: 'hidden',
                    '& #content': {
                        paddingTop: pxToEm(10)
                    },
                    '&.step': {
                        flex: '1'
                    }
                }
            }
        },

        // image selector is shown
        '&.imageSelectorActive-true': {
            '& #main': {
                '& #wrapper': {
                    display: 'flex',
                    '& .page': {
                        flex: '1 0 auto'
                    }
                }
            }
        },


        // ..... SECTION ANIMATIONS ..... //
        // individual page element animations are in each page stylesheet
        // embed controlls
        '& .embedcontrols': {
            '& .name-backtoembeds': {
                opacity: '0',
                animationName: 'fadeInLeft',
                animationDelay: '1s',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
            },
            '& .embedname': {
                opacity: '0',
                animationName: 'fadeInDown',
                animationDelay: '1s',
                animationDuration: '.2s',
                animationFillMode: 'forwards'
            },
            '& .ctas': {
                opacity: '0',
                animationName: 'fadeInRight',
                animationDelay: '1s',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
            }
        },
        // copy
        '& #content': {
            '& > .copy': {
                opacity: '0',
                animationName: 'fadeIn',
                animationDelay: '.3s',
                animationDuration: '.4s',
                animationFillMode: 'forwards',
            }
        },
        // step navigation
        '& .stepnav': {
            '& .stepnavitem': { 
                opacity: '0',
                animationDelay: '1s',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                '&.next': { animationName: 'fadeInRight' },
                '&.previous': { animationName: 'fadeInLeft' }
            }
        },
        '& .embedupdatecta': {
                opacity: '0',
                animationDelay: '1s',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                animationName: 'fadeInRight'
        },
        '&.isSavingData-true': {
            '& #main': {
                extend: disable
            }
        }
    }
});
